export default class MemberSettings {
    static fromData(data) {
        if (!data) {
            return;
        }

        let memberSettings = new MemberSettings();
        memberSettings.membershipNumberPrefix = data.membershipNumberPrefix;
        memberSettings.membershipNumberSuffix = data.membershipNumberSuffix;
        memberSettings.membershipNumberRangeStart = data.membershipNumberRangeStart;
        memberSettings.membershipNumberLeadingZeros = data.membershipNumberLeadingZeros;
        memberSettings.membershipNumberDigits = data.membershipNumberDigits;
        memberSettings.membershipNumberRecycling = data.membershipNumberRecycling;
        memberSettings.counterBasedOnPreAndSuffix = data.counterBasedOnPreAndSuffix;

        return memberSettings;
    }
}
